package top.wcpe.allincore.ui.runtime.event

import kotlin.jvm.JvmStatic

/**
 * 鼠标按键名的 commonMain 镜像（ADR-0068 §2「中立镜像 + JVM 适配」范式）。
 *
 * 真源（SSOT）是 `platform-client-api` 的 `top.wcpe.allincore.common.input.mouse.MouseButtons`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）；本镜像使 [MouseEvent] 等事件模型可迁
 * commonMain 供 JS 端复用。**两份定义的一致性由 jvmTest 的 MouseButtonNamesConsistencyTest
 * 逐常量、逐 code 断言守护**——真源改动而镜像未同步时测试即红。
 *
 * 映射为 GLFW button 编号约定（0=左 1=右 2=中 3..6=侧键），极稳定。
 */
internal object MouseButtonNames {

    /** 左键。 */
    const val LEFT = "Left"

    /** 右键。 */
    const val RIGHT = "Right"

    /** 中键。 */
    const val MIDDLE = "Middle"

    /** 侧键「后退」（GLFW button 3）。 */
    const val MOUSE_BACK = "MouseBack"

    /** 侧键「前进」（GLFW button 4）。 */
    const val MOUSE_FORWARD = "MouseForward"

    /** 第六个鼠标键（GLFW button 5）。 */
    const val MOUSE_BUTTON_6 = "MouseButton6"

    /** 第七个鼠标键（GLFW button 6）。 */
    const val MOUSE_BUTTON_7 = "MouseButton7"

    /** 未识别按键的统一回退值。 */
    const val UNKNOWN = ""

    /** GLFW button 编号 → 字符串名（与真源 MouseButtons.fromCode 逐 code 一致）。 */
    @JvmStatic
    fun fromCode(button: Int): String = when (button) {
        0 -> LEFT
        1 -> RIGHT
        2 -> MIDDLE
        3 -> MOUSE_BACK
        4 -> MOUSE_FORWARD
        5 -> MOUSE_BUTTON_6
        6 -> MOUSE_BUTTON_7
        else -> UNKNOWN
    }
}
